import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';

export function AnnouncementCategory({ children }: Readonly<PropsWithChildren>) {
  return <header className={bem('announcement__category')}>{children}</header>;
}
